module.exports = __webpack_public_path__ + "img/图层_46.d8ef37cd.png";